import React from 'react';
import { getCanonicalTypeInfo, removeSelectionStep } from '../../../data/analyticsDataSlice';
import { TpDataContext } from '../../../data/interfaces';
import { getEnSelectionFilterDef, isEmptyEnSelectionFilter } from '../../../data/selection/selectionEnFilters';
import styles from './SelectionFilterView.module.scss';
import { getSelectedItemCount, smartCountDisplayString } from '../helpers/misc';
import { TpEnSelectionFilterStep } from '../../../data/selection/interfaces';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useAppDispatch } from '../../../app/hooks';
import { selectionFilter2Element } from '../../../data/selection/selectionUtils';
import { DASHBOARD_ACTION_TRIGGERIDS } from '../actions/executeActionTriggers';
import { sendEvent } from '../hooks/events';

export interface TpSelectionFilterViewProps {
  dataContext: TpDataContext;
  canonicalTypeId: string;
}

export function SelectionFilterView({ dataContext, canonicalTypeId }: TpSelectionFilterViewProps) {
  const dispatch = useAppDispatch();

  const canonicalTypeInfo = getCanonicalTypeInfo(dataContext, canonicalTypeId);
  const filter = canonicalTypeInfo.selectionFilter;
  const isEmptyFilter = isEmptyEnSelectionFilter(filter);

  let selectionCount = getSelectedItemCount(canonicalTypeInfo);

  let totalCountOrig = 0;
  let totalCount = 0;
  for (const dataTable of dataContext.dataTables)
    if (dataTable.canonicalTypeId == canonicalTypeId) {
      let count = 0;
      for (const itemId of dataTable.columnData[dataTable.colItemId])
        if (!canonicalTypeInfo.restrictedItemsMap || canonicalTypeInfo.restrictedItemsMap[itemId]) count++;
      totalCount = Math.max(totalCount, count);
      totalCountOrig += dataTable.columnData[dataTable.colItemId].length;
    }

  if (isEmptyFilter) selectionCount = totalCount;

  const startPoint = (
    <div className={styles.endPoint} key="start">
      {smartCountDisplayString(totalCount)}
    </div>
  );
  const endPoint = (
    <div className={styles.endPoint} key="end">
      {smartCountDisplayString(selectionCount)}
    </div>
  );

  let manualSelectionStep = null;
  if (filter.manualSelection) {
    manualSelectionStep = (
      <div className={styles.andElement}>
        <div className={styles.manualSelectionElement}>Manual selection</div>
      </div>
    );
  }

  function renderFilterStep(step: TpEnSelectionFilterStep) {
    const content = getEnSelectionFilterDef(step.type).renderContent(dataContext, canonicalTypeInfo, step);
    return (
      <div className={styles.actionElement}>
        <div className={styles.actionElementText}>{content}</div>
        <div className={styles.actionInfoBox}>{step.includedCount}</div>
        <div
          className={styles.actionRemoveButton}
          onClick={() => {
            dispatch(
              removeSelectionStep({
                dataContextId: dataContext.id,
                canonicalTypeId,
                key: step.key,
              }),
            );
            sendEvent(DASHBOARD_ACTION_TRIGGERIDS.ENTITY_SELECTION_MODIFIED_BY_USER, {
              dataContextId: dataContext.id,
              canonicalTypeId,
            });
          }}
        >
          <FontAwesomeIcon icon="xmark" />
        </div>
      </div>
    );
  }

  let renderedFilter = (
    <div>
      {startPoint}
      <div className={styles.actionElement}>No filter</div>
      {endPoint}
    </div>
  );

  if (!isEmptyFilter) {
    renderedFilter = (
      <div className={styles.wrapper}>
        <div className={styles.andWrapper}>
          {startPoint}
          {filter.steps.map((step, index) => (
            <React.Fragment key={`el_${index}`}>
              <div className={styles.andElement}>{renderFilterStep(step)}</div>
            </React.Fragment>
          ))}
          {manualSelectionStep}
          {endPoint}
        </div>
      </div>
    );
  }

  return (
    <div>
      <div className={styles.title}>{canonicalTypeInfo.name} Filter</div>
      <div>{selectionFilter2Element(dataContext, canonicalTypeId, canonicalTypeInfo.restrictionFilter)}</div>
      <div className={styles.wrapper}>{renderedFilter}</div>
    </div>
  );
}
